function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFiligrane = function SvgFiligrane(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 6955 7452"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M2365.42 3635.83c-25.834-36.666-82.917-24.166-91.25 20L1607.503 7192.5c-10 53.75 60 83.333 91.25 38.75l1560.42-2204.17c27.5-38.75 27.5-90.416 0-128.75l-893.75-1262.5ZM6657.92 2155h-1962.5c-31.667 0-55.417 28.75-49.584 59.583l148.75 790c5.834 31.667 40 50 69.584 37.084l1813.75-790.417c50-21.667 34.583-96.25-20-96.25Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#d0d0d0",
      strokeWidth: "4.17px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4395.83 2197.08c-4.583-24.583-25.833-42.083-50.833-42.083H260.827c-55.833 0-71.666 76.667-20.416 98.75l2064.17 900c51.25 22.083 95 58.333 127.5 103.333l2812.08 3971.25c32.083 45.417 102.916 15 92.916-39.583l-941.25-4991.67ZM2555.42 1575.83l1825.83-582.916c124.583-39.584 120-81.667-10.417-92.917l-371.25-32.5L3567.5 207.914c-18.75-28.334-56.667-36.25-85-17.917l-777.083 506.25c-20.834 13.75-31.667 38.75-27.084 63.333l102.5 519.584-267.916 218.333c-101.25 82.917-82.5 118.333 42.5 78.333Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#d0d0d0",
      strokeWidth: "4.17px"
    }
  }));
};
export default SvgFiligrane;